import ApiCaller from "api/apiCaller";
import { StoreStatistic } from "Models/store";
import SiteStatisticItem from "pages/Site/components/SiteStatisticItem";
import React, { useEffect, useState, useRef } from "react";
import "../../style/storelisting.scss";
import { StoreListingProps } from "../../type";
import { useHistory } from "react-router-dom";
import { Row } from "reactstrap";
import StoreListingFilter from "../components/StoreListingFilter";
import _ from "lodash";
import Loading from "components/Loading";
import StoreListingPagination from "../components/StoreListingPagination";
import StoreListingTable from "../components/StoreListingTable";
import { TableMapping } from "shared/components/Table/type";
import t from "utils/Lang";
import numeral from "numeral";

const StoreName = ({ store }: { store: any }) => {
  return (
    <div className="site-name-container">
      <span className="site-name">{store?.name || "Chưa có tên"}</span>
    </div>
  );
};

const diffMonth = (d1?: Date | null, d2?: Date | null) => {
  if (!d1 || !d2) return "";
  let months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
};

const tableMapping: Array<TableMapping> = [
  {
    label: t().store_listing__id,
    mappingKeys: ["id"],
    isActive: true,
    isFiltered: null,
    id: "0",
  },
  {
    label: t().store_listing__city,
    mappingKeys: ["city", "name"],
    isActive: true,
    isFiltered: null,
    id: "1",
  },
  {
    label: t().store_listing__store_name,
    mappingKeys: ["name"],
    defaultVal: "Chưa có tên",
    customComponent: (store: any) => <StoreName store={store} />,
    isActive: true,
    isFiltered: null,
    id: "2",
  },
  {
    id: "3",
    label: t().store_listing__contract_from,
    mappingKeys: ["contract_from"],
    defaultVal: null,
    customComponent: (store: any) => (
      <span>{store.contract?.available_from}</span>
    ),
    isActive: true,
    isFiltered: null,
  },
  {
    id: "4",
    label: t().store_listing__contract_to,
    mappingKeys: ["contract_to"],
    defaultVal: null,
    customComponent: (store: any) => (
      <span>{store.contract?.available_to}</span>
    ),
    isActive: true,
    isFiltered: null,
  },
  {
    id: "5",
    label: t().store_listing__open_date,
    mappingKeys: ["grand_opening_date"],
    defaultVal: null,
    isActive: true,
    isFiltered: null,
  },
  {
    id: "6",
    label: t().store_listing__active_month,
    mappingKeys: ["active_month"],
    defaultVal: null,
    customComponent: (store: any) => (
      <span>
        {diffMonth(
          store.grand_opening_date ? new Date(store.grand_opening_date) : null,
          new Date()
        )}
      </span>
    ),
    isActive: true,
    isFiltered: null,
  },
  {
    id: "7",
    label: t().site_listing__deposit,
    mappingKeys: ["contract", "deposit_fee"],
    defaultVal: null,
    customComponent: null,
    isActive: true,
    isFiltered: null,
  },
  {
    id: "8",
    label: t().site_listing__initial_lease_rate,
    mappingKeys: ["site", "initial_lease_rate"],
    defaultVal: null,
    customComponent: (store: any) => (
      <span>{numeral(store?.site?.initial_lease_rate || 0).format("0,0")}</span>
    ),
    isActive: true,
    isFiltered: null,
  },
  {
    id: "9",
    label: t().site_listing__payment_cycle,
    mappingKeys: ["contract", "payment_period_monthly_cycle"],
    defaultVal: null,
    customComponent: null,
    isActive: true,
    isFiltered: null,
  },
  {
    id: "10",
    label: t().site_listing__status,
    mappingKeys: ["status", "name"],
    defaultVal: null,
    customComponent: null,
    isActive: true,
    isFiltered: null,
  },
  {
    id: "11",
    label: t().store_listing__contract_status,
    mappingKeys: ["status"],
    defaultVal: null,
    customComponent: (store: any) => {
      const expireDate = store?.contract?.available_to;
      const diff = diffMonth(
        new Date(),
        expireDate ? new Date(expireDate) : null
      );
      if (!diff) return <span></span>;
      return (
        <span>{diff < 6 ? t().contract__renew : t().contract__active}</span>
      );
    },
    isActive: true,
    isFiltered: null,
  },
];

const initialStoreData = {
  stores: [],
  page: 0,
  totalPage: 0,
  limit: 10,
  loading: true,
  tableMapping,
};

const StoreListing = ({
  onChangeStatus,
  onStoreClick,
  status,
  storeStatistic,
}: StoreListingProps) => {
  const [storeData, setStoreData] = useState(initialStoreData);
  const history = useHistory();
  const [statusOptions, setStatusOptions] = useState<Array<any>>([]);
  const [searchData, setSearchData] = useState("");
  const getStatusListing = async () => {
    let options = [
      {
        label: t().site_listing__all,
        value: "all",
      },
    ];
    const res = await ApiCaller.get(
      `status/?q=(filters:!((col:content_type,opr:eq,value:store)))`
    );
    if (res?.result) {
      res?.result?.forEach((item: any) => {
        options.push({
          value: item?.id,
          label: item?.name,
        });
      });

      setStatusOptions(options);
    }
  };
  useEffect(() => {
    getStatusListing();
  }, []);

  const onFilterData = (type: string, data: any) => {
    if (type == "status") {
      onChangeStatus(data?.[0]?.value);
      return;
    }
    if (type == "search") {
      onSearch(data);
    }
  };
  useEffect(() => {
    getStoreListing();
  }, [storeData.page, status, searchData]);
  const onSearch = _.debounce((data: any) => {
    if (!status) {
      onChangeStatus("all");
    }
    setSearchData(data);
  }, 500);
  const getStoreListing = async () => {
    if (!status) return;
    let siteFilterString = "";
    if (searchData !== "") {
      siteFilterString = siteFilterString + `&name=${searchData}`;
    }
    if (status !== "all") {
      siteFilterString = siteFilterString + `&status_id=${status}`;
    }
    const res = await ApiCaller.get(
      `store/list_v2?page=${storeData.page <= 0 ? 0 : storeData.page}&limit=${storeData.limit}&order_by=name&order_direction=asc${siteFilterString}`
    );
    if (res?.result) {
      setStoreData((data) => ({
        ...data,
        stores: res?.result,
        totalPage: Math.floor(res?.total / storeData?.limit) + 1,
        loading: false,
        page: data.page,
      }));
    } else {
      setStoreData({ ...storeData, loading: false });
    }
  };

  const onPageChange = (page: number) => {
    let pageNumber = 0;
    if (page <= 0) {
      pageNumber= 0
    } else {
      pageNumber = page - 1;
    }
    setStoreData({
      ...storeData,
      page: pageNumber,
    });
  };

  const onFiltered = (index: number, isFiltered: boolean) => {};

  if (!status) {
    const renderStatisticItem = (item: StoreStatistic) => {
      const handleClick = () => {
        history.replace(`/store?status=${item.id}`);
      };
      return (
        <SiteStatisticItem key={item.id} item={item} onClick={handleClick} />
      );
    };
    return (
      <div className="store-manager">
        <StoreListingFilter
          dataStatus={statusOptions}
          currentStatus={status}
          onFilter={onFilterData}
        />
        <Row xs="1" sm="2" md="4">
          {storeStatistic?.map(renderStatisticItem)}
        </Row>
      </div>
    );
  }
  return (
    <div className="store-listing-container">
      <StoreListingFilter
        dataStatus={statusOptions}
        currentStatus={status}
        onFilter={onFilterData}
      />
      {(storeData.loading && <Loading />) || (
        <StoreListingTable
          onRowClick={onStoreClick}
          stores={storeData.stores}
          tableMapping={storeData.tableMapping}
          onFiltered={onFiltered}
        />
      )}
      <StoreListingPagination
        totalPage={storeData.totalPage}
        onChange={onPageChange}
      />
    </div>
  );
};

export default StoreListing;
